import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const CardRoot = superstyled({
  name: 'WhatToKnowCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.border.main}`
  })
});

export const ContentContainer = superstyled({
  name: 'WhatToKnowCard',
  slot: 'ContentContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(3)
    }
  })
});

export const InfoSection = superstyled({
  name: 'WhatToKnowCard',
  slot: 'InfoSection',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    flex: '1 1 50%'
  })
});

export const Label = superstyled({
  name: 'WhatToKnowCard',
  slot: 'Label',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  })
});

export const Title = superstyled({
  name: 'WhatToKnowCard',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.blue?.[800] || '#1B52C6',
    lineHeight: 1.3
  })
});

export const Description = superstyled({
  name: 'WhatToKnowCard',
  slot: 'Description',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    lineHeight: 1.5
  })
});

export const ChecklistSection = superstyled({
  name: 'WhatToKnowCard',
  slot: 'ChecklistSection',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flex: '1 1 50%'
  })
});

export const ChecklistItem = superstyled({
  name: 'WhatToKnowCard',
  slot: 'ChecklistItem',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5)
  })
});

export const CheckIcon = superstyled({
  name: 'WhatToKnowCard',
  slot: 'CheckIcon',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    color: theme.palette.primary.main,
    flexShrink: 0,
    marginTop: theme.spacing(0.25),
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem'
    }
  })
});

export const ChecklistText = superstyled({
  name: 'WhatToKnowCard',
  slot: 'ChecklistText',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    lineHeight: 1.5,
    flex: 1
  })
});
